/* eslint-disable no-restricted-globals */
// Author: Sunil Jain [Date: 2025-03-25 Tue 02:07 PM EDT]
// src/serviceWorkerRegistration.js
// This optional code is used to register a service worker.
// register() is not called by default.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on subsequent visits to a page, after all the
// existing tabs open on the page have been closed, since previously cached
// resources are updated in the background.

// To learn more about the benefits of this model and instructions on how to
// opt-in, read https://cra.link/PWA

/* eslint-env serviceworker */

const isLocalhost = Boolean(
    window.location.hostname === 'localhost' ||
      // [::1] is the IPv6 localhost address.
      window.location.hostname === '[::1]' ||
      // 127.0.0.0/8 are considered localhost for IPv4.
      window.location.hostname.match(
        /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
      )
);

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
    if (!base64String || typeof base64String !== 'string') {
        console.warn("ServiceWorker: VAPID public key is missing or invalid.");
        return new Uint8Array(0);
    }
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}
// --- END NEW UTILITY FUNCTIONS ---

export function register(config) {
    if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
      // The URL constructor is available in all browsers that support SW.
      const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
      if (publicUrl.origin !== window.location.origin) {
        // Our service worker won't work if PUBLIC_URL is on a different origin
        // from what our page is served on. This might happen if a CDN is used to
        // serve assets; see https://github.com/facebook/create-react-app/issues/2374
        return;
      }
  
      window.addEventListener('load', () => {
        const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;
  
        if (isLocalhost) {
          // This is running on localhost. Let's check if a service worker still exists or not.
          checkValidServiceWorker(swUrl, config);
  
          // Add some additional logging to localhost, pointing developers to the
          // service worker/PWA documentation.
          navigator.serviceWorker.ready.then(() => {
            console.log(
              'This web app is being served cache-first by a service ' +
                'worker. To learn more, visit https://cra.link/PWA'
            );
          });
        } else {
          // Is not localhost. Just register service worker
          registerValidSW(swUrl, config);
        }
      });
    }
  }


  function registerValidSW(swUrl, config) {
    navigator.serviceWorker
      .register(swUrl)
      .then((registration) => {
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker == null) {
            return;
          }
          installingWorker.onstatechange = () => {
            if (installingWorker.state === 'installed') {
              
              if (navigator.serviceWorker.controller) {
                // At this point, the updated precached content has been fetched,
                // but the previous service worker will still serve the older
                // content until all client tabs are closed.
                console.log(
                  'New content is available. Awaiting user action to reload.'
                );
  
                // Execute callback, which will show the update prompt in App.js
                if (config && config.onUpdate) {
                  config.onUpdate(registration);
                }
              } else {


                // At this point, everything has been precached.
                // It's the perfect time to display a
                // "Content is cached for offline use." message.
                console.log('Content is cached for offline use.');
  
                // Execute callback
                if (config && config.onSuccess) {
                  config.onSuccess(registration);
                }
              }
            }
          };
        };
        return registration; // <<< ADD THIS LINE
      })
      // The push notification logic needs to be INSIDE the .then() block
      // after the service worker registration has successfully resolved.
      .then(async (registration) => { // Added 'async' and moved inner logic
        if ('PushManager' in window && Notification.permission !== 'denied') {
            console.log('PushManager is supported. Checking for existing subscription or requesting permission.');

            const existingSubscription = await registration.pushManager.getSubscription();

            if (existingSubscription) {
                console.log('Existing push subscription found:', existingSubscription);
                // Optionally send existingSubscription to your backend if not already done
                // or verify it's still valid.
                if (config && config.onSubscriptionChange) {
                    config.onSubscriptionChange(existingSubscription);
                }
            } else {
                console.log('No existing push subscription. Permission will be requested by user action.');
            }
        } else {
            console.warn('Push notifications are not supported in this browser or permission is denied.');
        }
        return registration; // Ensure registration object is passed down the chain
      }) // End of new .then() block
      .catch(error => {
        console.error('Error during service worker registration:', error);
      });
  }

  function checkValidServiceWorker(swUrl, config) {
    // Check if the service worker can be found. If it can't reload the page.
    fetch(swUrl, {
      headers: { 'Service-Worker': 'script' },
    })
      .then((response) => {
        // Ensure service worker exists, and that we really are getting a JS file.
        const contentType = response.headers.get('content-type');
        if (
          response.status === 404 ||
          (contentType != null && contentType.indexOf('javascript') === -1)
        ) {
          // No service worker found. Probably a different app. Reload the page.
          navigator.serviceWorker.ready.then((registration) => {
            registration.unregister().then(() => {
              window.location.reload();
            });
          });
        } else {
          // Service worker found. Proceed as normal.
          registerValidSW(swUrl, config);
        }
      })
      .catch(() => {
        console.log(
          'No internet connection found. App is running in offline mode.'
        );
      });
  }
  
  export function unregister() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((registration) => {
          registration.unregister();
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
  }

// --- NEW: Function to request and subscribe for push notifications ---
export async function subscribeUserToPush(onSubscriptionSuccess, onSubscriptionError) {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.warn('Push notifications not supported by this browser.');
        if (typeof onSubscriptionError === 'function') {
            onSubscriptionError('Push notifications not supported by your browser.');
        }
        return;
    }

    if (Notification.permission === 'denied') {
        console.warn('Push permission already denied.');
        if (typeof onSubscriptionError === 'function') {
            onSubscriptionError('Push notifications are blocked by your browser. Please enable them in your browser settings.');
        }
        return;
    }

    try {
        const registration = await navigator.serviceWorker.ready;
        const existingSubscription = await registration.pushManager.getSubscription();

        if (existingSubscription) {
            console.log('Already subscribed:', existingSubscription);
            if (typeof onSubscriptionSuccess === 'function') {
                onSubscriptionSuccess(existingSubscription);
            }
            return existingSubscription;
        }

        console.log('Attempting to subscribe...');
        const subscribeOptions = {
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
        };
        const subscription = await registration.pushManager.subscribe(subscribeOptions);
        console.log('User is subscribed:', subscription);
        if (typeof onSubscriptionSuccess === 'function') {
            onSubscriptionSuccess(subscription);
        }
        return subscription;

    } catch (error) {
        console.error('Failed to subscribe the user: ', error);
        if (typeof onSubscriptionError === 'function') {
            if (Notification.permission === 'denied') {
                onSubscriptionError('Push notifications are blocked. Please enable them in your browser settings.');
            } else {
                onSubscriptionError(`Failed to subscribe: ${error.message || 'Unknown error'}`);
            }
        }
        throw error; // Re-throw to propagate if needed by calling component
    }
}

// --- NEW: Function to unsubscribe from push notifications ---
export async function unsubscribeUserFromPush(onUnsubscriptionSuccess, onUnsubscriptionError) {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
        console.warn('Push notifications not supported by this browser.');
        onUnsubscriptionError('Push notifications not supported by your browser.');
        return;
    }

    try {
        const registration = await navigator.serviceWorker.ready;
        const subscription = await registration.pushManager.getSubscription();

        if (subscription) {
            const successful = await subscription.unsubscribe();
            if (successful) {
                console.log('User is unsubscribed.');
                onUnsubscriptionSuccess(true);
                return true;
            } else {
                console.error('Failed to unsubscribe from push.');
                onUnsubscriptionError('Failed to unsubscribe from push. Please try again.');
                return false;
            }
        } else {
            console.log('User was not subscribed.');
            onUnsubscriptionSuccess(false); // No subscription to remove
            return false;
        }
    } catch (error) {
        console.error('Error during unsubscription: ', error);
        onUnsubscriptionError(`Error during unsubscription: ${error.message || 'Unknown error'}`);
        throw error;
    }
}

// --- NEW: Function to check current notification permission status ---
export function getNotificationPermissionStatus() {
    return Notification.permission;
}
/* eslint-enable no-restricted-globals */